import React, { FC, ReactNode } from 'react';
import { InView } from 'react-intersection-observer';

import { useAnalytics, postSegmentEvent } from '@lib/segment';

export enum ImpressionType {
  TRACK = 'TRACK',
  PAGE = 'PAGE',
  POST = 'POST',
}
interface SegmentImpressionProps {
  eventName: string;
  eventProps?: Record<string, any>;
  children: ReactNode;
  className?: string;
  eventType?: ImpressionType;
}

const SegmentImpression: FC<SegmentImpressionProps> = ({
  eventName,
  eventProps = {},
  children,
  className,
  eventType = ImpressionType.TRACK,
}) => {
  const { segmentPage, segmentTrack } = useAnalytics();
  const handleViewChange = (inView) => {
    if (inView) {
      if (eventType === ImpressionType.PAGE) {
        segmentPage(eventName, eventProps);
      } else if (eventType === ImpressionType.POST) {
        postSegmentEvent(eventName, eventProps);
      } else {
        segmentTrack(eventName, eventProps);
      }
    }
  };

  return (
    <InView
      // By default a div is rendered but this often affects flex layouts
      as="span"
      onChange={handleViewChange}
      className={className}
      triggerOnce
    >
      {children}
    </InView>
  );
};

export default SegmentImpression;
